import { render, staticRenderFns } from "./TicketIndex.vue?vue&type=template&id=7e851472&scoped=true&"
import script from "./TicketIndex.vue?vue&type=script&lang=js&"
export * from "./TicketIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e851472",
  null
  
)

export default component.exports